/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationInstanceEntity } from './IntegrationInstanceEntity';
import {
    IntegrationInstanceEntityFromJSON,
    IntegrationInstanceEntityFromJSONTyped,
    IntegrationInstanceEntityToJSON,
    IntegrationInstanceEntityToJSONTyped,
} from './IntegrationInstanceEntity';

/**
 * Mapping entity
 * @export
 * @interface IntegrationMappingEntity
 */
export interface IntegrationMappingEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    id?: string;
    /**
     * 
     * @type {IntegrationInstanceEntity}
     * @memberof IntegrationMappingEntity
     */
    instance?: IntegrationInstanceEntity;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    mappingName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    destinationTable?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    fieldMappings?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    transformations?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    filterRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    filterRuleConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    labelRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    labelRuleConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    targetTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    targetTenantResolver?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationMappingEntity
     */
    isCatchAll?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationMappingEntity
     */
    isDefault?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationMappingEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationMappingEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationMappingEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationMappingEntity
     */
    versionNumber?: number;
}

/**
 * Check if a given object implements the IntegrationMappingEntity interface.
 */
export function instanceOfIntegrationMappingEntity(value: object): value is IntegrationMappingEntity {
    return true;
}

export function IntegrationMappingEntityFromJSON(json: any): IntegrationMappingEntity {
    return IntegrationMappingEntityFromJSONTyped(json, false);
}

export function IntegrationMappingEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationMappingEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'instance': json['instance'] == null ? undefined : IntegrationInstanceEntityFromJSON(json['instance']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'mappingName': json['mappingName'] == null ? undefined : json['mappingName'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'destinationTable': json['destinationTable'] == null ? undefined : json['destinationTable'],
        'fieldMappings': json['fieldMappings'] == null ? undefined : json['fieldMappings'],
        'transformations': json['transformations'] == null ? undefined : json['transformations'],
        'filterRuleId': json['filterRuleId'] == null ? undefined : json['filterRuleId'],
        'filterRuleConfig': json['filterRuleConfig'] == null ? undefined : json['filterRuleConfig'],
        'labelRuleId': json['labelRuleId'] == null ? undefined : json['labelRuleId'],
        'labelRuleConfig': json['labelRuleConfig'] == null ? undefined : json['labelRuleConfig'],
        'targetTenantId': json['targetTenantId'] == null ? undefined : json['targetTenantId'],
        'targetTenantResolver': json['targetTenantResolver'] == null ? undefined : json['targetTenantResolver'],
        'isCatchAll': json['isCatchAll'] == null ? undefined : json['isCatchAll'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'versionNumber': json['versionNumber'] == null ? undefined : json['versionNumber'],
    };
}

export function IntegrationMappingEntityToJSON(json: any): IntegrationMappingEntity {
    return IntegrationMappingEntityToJSONTyped(json, false);
}

export function IntegrationMappingEntityToJSONTyped(value?: IntegrationMappingEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'instance': IntegrationInstanceEntityToJSON(value['instance']),
        'tenantId': value['tenantId'],
        'mappingName': value['mappingName'],
        'sourceSystem': value['sourceSystem'],
        'destinationTable': value['destinationTable'],
        'fieldMappings': value['fieldMappings'],
        'transformations': value['transformations'],
        'filterRuleId': value['filterRuleId'],
        'filterRuleConfig': value['filterRuleConfig'],
        'labelRuleId': value['labelRuleId'],
        'labelRuleConfig': value['labelRuleConfig'],
        'targetTenantId': value['targetTenantId'],
        'targetTenantResolver': value['targetTenantResolver'],
        'isCatchAll': value['isCatchAll'],
        'isDefault': value['isDefault'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'versionNumber': value['versionNumber'],
    };
}

